"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = exports.ShareTypes = void 0;
var headers_1 = require("../../shared/headers");
var client_1 = require("../../shared/http/client");
exports.ShareTypes = __importStar(require("./types"));
var Share = /** @class */ (function () {
    function Share(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
    }
    Share.client = function (apiUrl, appDetails, apiSecurity) {
        return new Share(apiUrl, appDetails, apiSecurity);
    };
    /**
     * Creates a new link to share a file
     * @param payload
     */
    Share.prototype.createShareFileLink = function (payload) {
        return this.client
            .post("/storage/share/file/" + payload.fileId, {
            views: payload.views,
            encryptionKey: payload.encryptionKey,
            fileToken: payload.fileToken,
            bucket: payload.bucket,
        }, this.headers());
    };
    /**
     * Creates a new link to share a folder
     * @param payload
     */
    Share.prototype.createShareFolderLink = function (payload) {
        return this.client
            .post("/storage/share/folder/" + payload.folderId, {
            views: payload.views,
            bucketToken: payload.bucketToken,
            bucket: payload.bucket,
            mnemonic: payload.encryptedMnemonic
        }, this.headers());
    };
    /**
     * Fetches the list of shared items
     */
    Share.prototype.getShareList = function () {
        return this.client
            .get('/share/list', this.headers());
    };
    /**
     * Fetches data of a shared file
     * @param token
     */
    Share.prototype.getSharedFileByToken = function (token) {
        return this.client
            .get("/storage/share/" + token, this.basicHeaders());
    };
    /**
     * Fetches data of a shared folder
     * @param token
     */
    Share.prototype.getSharedFolderByToken = function (token) {
        return this.client
            .get("/storage/shared-folder/" + token, this.basicHeaders());
    };
    /**
     * Fetches paginated folders of a specific shared folder
     * @param payload
     */
    Share.prototype.getSharedDirectoryFolders = function (payload) {
        return this.client
            .get("/storage/share/down/folders?token=" + payload.token + "&directoryId=" + payload.directoryId + "&offset=" + payload.offset + "&limit=" + payload.limit, this.basicHeaders());
    };
    /**
     * Fetches paginated files of a specific shared folder
     * @param payload
     */
    Share.prototype.getSharedDirectoryFiles = function (payload) {
        return this.client
            .get("/storage/share/down/files?code=" + payload.code + "&token=" + payload.token + "&directoryId=" + payload.directoryId + "&offset=" + payload.offset + "&limit=" + payload.limit, this.basicHeaders());
    };
    /**
     * Returns the needed headers for the module requests
     * @private
     */
    Share.prototype.headers = function () {
        return (0, headers_1.headersWithTokenAndMnemonic)(this.appDetails.clientName, this.appDetails.clientVersion, this.apiSecurity.token, this.apiSecurity.mnemonic);
    };
    /**
     * Returns the needed headers for the module requests
     * @private
     */
    Share.prototype.basicHeaders = function () {
        return (0, headers_1.basicHeaders)(this.appDetails.clientName, this.appDetails.clientVersion);
    };
    return Share;
}());
exports.Share = Share;
